<template>
  <header>
    <div class="title">
      <div class="bg"></div>
      <h1>
        <img class="title-img" src="images/title-bg.png" alt="叶老师的奇门遁甲之道">
        <span>叶老师的奇门遁甲之道</span>
      </h1>
      <span class="tel" @click="$emit('showHotLine')">
        <button>起名热线</button>
      </span>
    </div>
  </header>
</template>

<script>
export default {
  name: 'page-header'
}
</script>

<style scoped lang="scss">
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 4.8rem;
    white-space: nowrap;
    .bg{
      display: none;
    }
    h1 {
      position: relative;
      margin: 0;
      height: 48px;
      overflow: hidden;
      .title-img{
        position: absolute;
        top: 0;
        height: 48px;
        opacity: .92;
      }
      span{
        line-height: 100;
      }
    }
    .tel {
      display: block;
      button {
        font-size: 1.6rem;
        background-color: $red;
        border: none;
        outline: none;
        padding: 5px 12px;
        border-radius: 5px;
        color: #fff;
      }
    }
  }
  .mobile{
    header{
      position: sticky;
      top: 0;
      z-index: 2;
    }
    .title{
      margin: 0 -15px;
      padding-left: 15px;
      background: rgba(230,218,180,1);
      background: -moz-linear-gradient(45deg, rgba(230,218,180,1) 0%, rgba(240,235,218,1) 100%);
      background: -webkit-gradient(left bottom, right top, color-stop(0%, rgba(230,218,180,1)), color-stop(100%, rgba(240,235,218,1)));
      background: -webkit-linear-gradient(45deg, rgba(230,218,180,1) 0%, rgba(240,235,218,1) 100%);
      background: -o-linear-gradient(45deg, rgba(230,218,180,1) 0%, rgba(240,235,218,1) 100%);
      background: -ms-linear-gradient(45deg, rgba(230,218,180,1) 0%, rgba(240,235,218,1) 100%);
      background: linear-gradient(45deg, rgba(230,218,180,1) 0%, rgba(240,235,218,1) 100%);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e6dab4', endColorstr='#f0ebda', GradientType=1 );
      line-height: 48px;
      border-bottom: #fff5d7 thin solid;
      box-shadow: rgba(0,0,0,.3) 0 0 5px;
      .bg{
        display: block;
        background: url("../assets/images/it-shadow-bg.png") no-repeat center;
        background-size: 100%;
      }
      h1{
        font-size: 2.1rem;
        text-shadow: rgba(255, 255, 255, 0.64) 0 1px 0;
      }
      .tel{
        font-size: 1.8rem;
        padding: 0 5px;
        background-color: $red;
      }
    }
  }
</style>
